export const pageName = {
	attributes: 'Guided Workflow V2',
	body: 'Body',
	forms: 'Questions And Responses',
	changes: 'Track Changes',
	compare: 'Compare Resources',
    relatedDocuments: 'Related Documents',
	configurations: 'Configurations',
	conclusion: 'Conclusion',
	cookieSettings: 'Cookie Settings',
	details: 'Form Details',
	document: 'Document',
	errorPage: 'Error Page',
	fit: 'Fit',
	guidedWorkFlow: 'Guided Workflow',
	guidedWorkFlowV2: 'Main Activities',
	header: 'Header',
	independence: 'Independence',
	print: 'Print',
	profile: 'Profile',
	section: 'Section',
	standAlone: 'Stand Alone',
	summary: 'Summary',
	view: 'View'
};

export const siteSection = {
	attributes: 'Guided Workflow V2',
	changes: 'Track Changes',
	compare: 'Compare Resources',
	relatedDocuments: 'Related Documents',
	configurations: 'Configurations',
	consent: 'Consent',
	details: 'Form Details',
	document: 'Document',
	documentHeader: 'DocumentHeader',
	documentSection: 'DocumentSection',
	errorPage: 'Error Page',
	fit: 'Fit',
	forms: 'Questions And Responses',
	guidedWorkFlow: 'Guided Workflow',
	guidedWorkFlowV2: 'Main Activities',
	independence: 'Independence',
	initProfile: 'Init Profile',
	print: 'Print',
	profile: 'Profile',
	standAlone: 'Stand Alone',
	documentSummary: 'DocumentSummary',
	compareDocument: 'CompareDocument',
	view: 'View'
};

export const delimiters = [
	':',
	'-',
	' ',
	'/',
	'|',
	'_'
];